import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { fontSize, fontWeight, lineHeight, spacing, color, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Label = styled(Box).attrs(function () {
  return {
    as: "label"
  };
}).withConfig({
  componentId: "oskls5-0"
})(["display:flex;flex-direction:row;align-items:center;font-size:", ";font-weight:", ";line-height:", ";margin-bottom:", ";color:", ";"], fontSize("base"), fontWeight("bold"), lineHeight("base"), spacing("xs"), color("text.base"));
var Description = styled(Box).withConfig({
  componentId: "oskls5-1"
})(["margin-bottom:", ";margin-top:-", ";"], spacing("xs"), spacing("xs"));
var ValidationMessage = styled(Box).withConfig({
  componentId: "oskls5-2"
})(["font-size:", ";line-height:", ";margin-top:", ";margin-bottom:", ";", " ", ""], fontSize("sm"), lineHeight("sm"), spacing("xs"), spacing("xs"), function (_ref) {
  var isInvalid = _ref.isInvalid;
  return isInvalid && css(["color:", ";"], palette("danger.500"));
}, function (_ref2) {
  var isValid = _ref2.isValid;
  return isValid && css(["color:", ";"], palette("success.500"));
});
var HelpText = styled(Box).withConfig({
  componentId: "oskls5-3"
})(["color:", ";font-size:", ";line-height:", ";margin-top:", ";margin-bottom:", ";"], color("text.low"), fontSize("sm"), lineHeight("sm"), spacing("xs"), spacing("xs"));
var FormControl = styled(Box).withConfig({
  componentId: "oskls5-4"
})(["width:100%;& + &{margin-top:", ";}"], spacing("sm"));
export { Description, FormControl, HelpText, Label, ValidationMessage };